<template>
  <div>
    <TOCSankeyInsight :metric-id="metricId" :entity-id="entityId"/>
  </div>
</template>

<script>
import TOCSankeyInsight from "@/components/Metric/Metric_Insights/51/51_3_TOC_SANKEY.vue";

export default {
  components: {
    TOCSankeyInsight
  },
  props: {
    entityId: {
      type: Number,
      default: null
    },
    year: { type: Number, default: null },
    metricId: { type: Number, default: 51 },
  }
}
</script>
